/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_See_PricingInputs */

const en_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See Pricing`)
};

const es_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver precios`)
};

const de_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siehe Preise`)
};

const zh_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看价格`)
};

const ar_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطّلع على الأسعار`)
};

const fr_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les tarifs`)
};

const vi_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem giá`)
};

const sw_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angalia Bei`)
};

const th_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูราคา`)
};

const bs_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pogledaj cijene`)
};

const ja_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`料金を見る`)
};

const ko_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가격 보기`)
};

const pt_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver preços`)
};

const it_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi il prezzo`)
};

const sv_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se prissättning`)
};

const nl_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zie Prijzen`)
};

const da_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se prissætning`)
};

const nb_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se priser`)
};

const fi_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ks. hinnoittelu`)
};

const pl_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zob. ceny`)
};

const ru_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смотрите цены`)
};

const tr_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyatlama`)
};

const hi_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल्य निर्धारण देखें`)
};

const id_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Harga`)
};

const ms_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Harga`)
};

const cs_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viz cena`)
};

const el_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δείτε τις τιμές`)
};

const he_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחיר`)
};

const af_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sien pryse`)
};

const hu_lessons_see_pricing = /** @type {(inputs: Lessons_See_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lásd árképzés`)
};

/**
* | output |
* | --- |
* | "See Pricing" |
*
* @param {Lessons_See_PricingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_see_pricing = /** @type {((inputs?: Lessons_See_PricingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_See_PricingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_see_pricing(inputs)
	if (locale === "de") return de_lessons_see_pricing(inputs)
	if (locale === "zh") return zh_lessons_see_pricing(inputs)
	if (locale === "ar") return ar_lessons_see_pricing(inputs)
	if (locale === "fr") return fr_lessons_see_pricing(inputs)
	if (locale === "vi") return vi_lessons_see_pricing(inputs)
	if (locale === "sw") return sw_lessons_see_pricing(inputs)
	if (locale === "th") return th_lessons_see_pricing(inputs)
	if (locale === "bs") return bs_lessons_see_pricing(inputs)
	if (locale === "ja") return ja_lessons_see_pricing(inputs)
	if (locale === "ko") return ko_lessons_see_pricing(inputs)
	if (locale === "pt") return pt_lessons_see_pricing(inputs)
	if (locale === "it") return it_lessons_see_pricing(inputs)
	if (locale === "sv") return sv_lessons_see_pricing(inputs)
	if (locale === "nl") return nl_lessons_see_pricing(inputs)
	if (locale === "da") return da_lessons_see_pricing(inputs)
	if (locale === "nb") return nb_lessons_see_pricing(inputs)
	if (locale === "fi") return fi_lessons_see_pricing(inputs)
	if (locale === "pl") return pl_lessons_see_pricing(inputs)
	if (locale === "ru") return ru_lessons_see_pricing(inputs)
	if (locale === "tr") return tr_lessons_see_pricing(inputs)
	if (locale === "hi") return hi_lessons_see_pricing(inputs)
	if (locale === "id") return id_lessons_see_pricing(inputs)
	if (locale === "ms") return ms_lessons_see_pricing(inputs)
	if (locale === "cs") return cs_lessons_see_pricing(inputs)
	if (locale === "el") return el_lessons_see_pricing(inputs)
	if (locale === "he") return he_lessons_see_pricing(inputs)
	if (locale === "af") return af_lessons_see_pricing(inputs)
	if (locale === "hu") return hu_lessons_see_pricing(inputs)
	return en_lessons_see_pricing(inputs)
});